import TYPES from './types';
import { get } from 'utils/api';
import {
  getDefaultListKey,
  updateDefaultListOptions,
  updateDefaultListTimestamp
} from 'common/utils/lists';
import _get from 'lodash/get';

const aliases = {
  'fuel-grades-with-prices': 'fuel-grades&with_prices=true',
  'logs-types': 'log-integration-type',
  'logs-statuses': 'log-status',
  'job-log-types': 'job-log-integration-type',
  'job-log-statuses': 'job-log-status',
  'identifier-types': 'identifier-types',
  'week-days': 'week-days',
  airport_types: 'airport-types',
  countries: 'countries',
  'vessel-document-categories': 'vessel-document-categories'
};

const customEndpointAliases = {
  'beacon-pages-suggestions': 'beacon/pages'
};

export const getListUrl = list => {
  const hasCustomUrl = customEndpointAliases[list];

  return !hasCustomUrl
    ? `/lists?list=${_get(aliases, list, list)}`
    : `${customEndpointAliases[list]}`;
};

export const fetchListOptions =
  (list, search = '', params) =>
  (dispatch, getState) => {
    dispatch({ type: TYPES.FETCH_OPTIONS.START, payload: { list } });

    const url = `${getListUrl(list)}${search ? `&search=${search}` : ''}`;

    const defaultLists = getState()?.lists?._defaults;
    const defaultListKey = getDefaultListKey(list, params);

    const { lastFetchedAt, options } = defaultLists?.[defaultListKey] || {};

    if (!search) {
      if (!lastFetchedAt) {
        dispatch(updateDefaultListTimestamp(list, params));
      } else if (lastFetchedAt && options?.length) {
        return new Promise(resolve => resolve(options));
      }
    }

    return get(url, params)
      .then(res => {
        const formattedOptions = res.data.map(item => {
          switch (list) {
            case 'parties':
              return {
                ...item,
                value: item.id,
                label: item.type === 'company' ? item.company_name : item.full_name
              };

            default:
              return item;
          }
        });
        dispatch({
          type: TYPES.FETCH_OPTIONS.SUCCESS,
          payload: { list, options: formattedOptions }
        });

        if (!search && !options?.length) {
          dispatch(updateDefaultListOptions(list, params, formattedOptions));
        }

        return options;
      })
      .catch(error => dispatch({ type: TYPES.FETCH_OPTIONS.ERROR, payload: { list, error } }));
  };
